import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { connect } from "react-redux";
import { useParams, useHistory, Link } from "react-router-dom";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import Divider from "@material-ui/core/Divider";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import moment from "moment";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import HttpService from "../services/httpService";
import { ROLENAME, refundCategory } from "../utils";
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles((theme) => ({
  table: {
    width: "100vw",
    textAlign: "center",
  },
  root: {
    width: "100%",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ccc",
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const RefundRequestApprovalView = (props) => {
  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);
  const history = useHistory();
  const [allRefundRequestData, setAllRefundRequestData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [status, setStatus] = useState("");
  const [remark, setRemark] = useState("");
  const [projectId, setProjectId] = useState("");
  const [refundAmount, setRefundAmount] = useState(0);
  const [index, setIndex] = useState();
  const [refundValue, setRefundValue] = useState(0);
  const [projectDetails, setProjectDetails] = useState({});
  const [commonExpCenter, setExpCenter] = useState([])
  const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
  const [items, setItems] = useState({
    delayPenality: 0,
    damages: 0,
    goodWillDiscount: 0,
    others: 0,
    referralBonus: 0,
  })                                 //storing index for edit refund amount which is editable

  useEffect(() => {
    getAllRefundRequestData();
    expCenters();
  }, []);

  const getAllRefundRequestData = async (selectedExpCenter) => {
    props.setLoading(true);
    try {
      const response = await HttpService.getAllRefundRequestData();
      allRefundRequestArray(response.data, selectedExpCenter);
    }
    catch (error) {
      props.setSnackInfo("Something went wrong", "error");
    }
    props.setLoading(false);
  };

  const allRefundRequestArray = (refundRaiseData, selectedExpCenter) => {
    let expCenterData = selectedExpCenter?.map((el) => el._id);
    const newArr = refundRaiseData.filter((row) => {
      if (expCenterData?.length > 0) {
        return expCenterData.includes(row.experienceCenterId);
      }
      return userDetails?.experienceCenterId?.includes(row.experienceCenterId);
    });
    setAllRefundRequestData(newArr);
  };

  const handleMultipleExpData = (event, newValue) => {
    setSelectedExperienceCenter(newValue)
    getAllRefundRequestData(newValue)
  }

  const expCenters = async () => {
    props.setLoading(true);
    try {
      let response = await HttpService.getExpericenCenters();
      const matchedUsers = response.data.filter(user => {
        return userDetails.experienceCenterId.includes(user._id);
      });
      setExpCenter(matchedUsers)
    } catch (error) {
      console.error("Error fetching experience centers:", error);
      props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
    }
    props.setLoading(false);
  }

  const updateRefundRequestStatus = async () => {
    props.setLoading(true);
    try {
      setOpenDialog(false);
      const {damage, damageId, delayPenality, delayPenalityId, goodWillDisc, goodWillDiscId, other, otherId, referralBonus, referralBonusId} = refundCategory;
      // Logic for update company p & L after approve finance manager from refund dashboard need to store that field when last refund approval person approved.
      let itemsArray = [];
      Object.entries(items).forEach(([key, value]) => {
        if(value > 0) {
          let refundItemsObj = {
            totalPrice: value,
          }
          if(key === 'damages'){
            refundItemsObj.productId = damageId
            refundItemsObj.productName = damage
          } else if(key === 'delayPenality'){
            refundItemsObj.productId = delayPenalityId
            refundItemsObj.productName = delayPenality
          } else if(key === 'goodWillDiscount'){
            refundItemsObj.productId = goodWillDiscId
            refundItemsObj.productName = goodWillDisc
          } else if(key === 'others'){
            refundItemsObj.productId = otherId
            refundItemsObj.productName = other
          } else if(key === 'referralBonus'){
            refundItemsObj.productId = referralBonusId
            refundItemsObj.productName = referralBonus
          }
          itemsArray.push(refundItemsObj)
        }
      });

      let obj = {
        status: status,
        remark: remark,
        items: items,
        refundAmount: refundAmount[index] ? refundAmount[index] : refundValue,
        erpProjectId:  projectDetails.erpProjectId,
        itemsArray : itemsArray,
      };

      if (userDetails.roles.some(role => [ROLENAME.DGM_Ops, ROLENAME.ExecutionHead].includes(role.name))) {
        const sum = Object.entries(items).reduce((acc, [, value]) => acc + value, 0);
        obj.refundAmount = sum;
      }

      const res = await HttpService.approveRefundRequestStatus(obj, projectId);
      if (res?.status === 202) {      //Raise Lost Approval - 201
        props.setSnackInfo("Wait for the raise lost approval and approve", "warning")
      }
      else if (res?.status === 201) {      //'Pending Lost Approval' - 201
        props.setSnackInfo("Wait until lost approval", "warning")
      }
      else {
        setOpenDialog(false);
        setRemark("");
      }
      getAllRefundRequestData();
    } catch (err) {
      props.setSnackInfo("Something went wrong", "error");
    }
    props.setLoading(false);
  };

  // handle approve button
  const handleApprove = (row) => {
    setOpenDialog(true);
    setStatus("Approved");
    setProjectId(row?._id)
    setRefundValue(row?.refundAmount);
    setProjectDetails(row);
    if (userDetails.roles.find(role => role.name === ROLENAME.DGM_Ops || role.name === ROLENAME.ExecutionHead)) {
      let name = Object?.keys(row?.chmRefundRequest)
      let value = Object?.values(row?.chmRefundRequest);

      for (let i = 0; i < name?.length; i++) {
        setItems((prev) => ({
          ...prev,
          [name[i]]: +value[i],
        }));
      }
    }
  }

  // handle reject button
  const handleReject = (row) => {
    setOpenDialog(true);
    setStatus("Rejected");
    setProjectId(row?._id);
    setRefundValue(row?.refundAmount);
  }

  // On change refund function
  const handleRefundAmountChange = (index, value) => {
    setIndex(index);
    setRefundAmount(prevState => ({
      ...prevState,
      [index]: +value,
    }));
  };

  // handle chm fill item delay penality to others
  const handleChmItems = (e) => {
    const { name, value } = e.target;
    setItems((prev) => ({
      ...prev,
      [name]: +value,
    }));
  }

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <h3 style={{ textAlign: "center" }}>
          Refund Request Approval Dashboard
        </h3>
      </div>

      {userDetails?.roles && userDetails.roles.some(role => [ROLENAME.DGM_Sales, ROLENAME.SalesHead].includes(role.name)) && (
        <div style={{ display: 'flex' }}>
          <FormControl style={{ width: '30%', marginTop: '0.4rem' }}>
            <Autocomplete
              multiple
              value={selectedExperienceCenter}
              onChange={handleMultipleExpData}
              options={commonExpCenter}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Exp-Center"
                  variant="outlined"
                />
              )}
            />
          </FormControl>
        </div>
      )}

      <TableContainer style={{ marginTop: 20}}>
        <Table
          className={classes.table}
          stickyHeader
          aria-label="sticky table"
        >
          <TableHead>
            <TableRow style={{ backgroundColor: "#333", color: "#fff" }}>
              <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Sl No.</TableCell>
              <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Customer Name</TableCell>
              <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Project No.</TableCell>
              <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Lead No.</TableCell>
              {(!userDetails.roles.find(role => role.name === ROLENAME.DGM_Ops || role.name === ROLENAME.ExecutionHead)) &&
                (<>
                  <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Amount Paid</TableCell>
                  <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Amount Refunded</TableCell>
                  <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Amount To Be Refunded</TableCell>
                  <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Balance Amount</TableCell>
                </>
                )}
              {(userDetails.roles.find(role => role.name === ROLENAME.DGM_Ops || role.name === ROLENAME.ExecutionHead)) &&
                <>
                  <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Amount Refunded</TableCell>
                  <TableCell style={{ width: '20%', textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Amount To Be Refunded</TableCell>
                </>
              }
              <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Raised By</TableCell>
              <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {allRefundRequestData && allRefundRequestData?.map((row, index) => {
              return (
                <TableRow>
                  <TableCell component="th">{index + 1}</TableCell>
                  <TableCell component="th">
                    {row?.customerId?.name}
                  </TableCell>
                  <TableCell component="th">{row?.erpProjectNo ? row?.erpProjectNo : '-'}</TableCell>
                  <TableCell component="th">
                    <Link
                      to={`/project-logs/${row._id}`}
                      style={{ color: "#000", textDecoration: "underline" }}
                    >
                      {row?.lead_no}
                    </Link>{" "}
                  </TableCell>
                  {(!userDetails.roles.find(role => role.name === ROLENAME.DGM_Ops || role.name === ROLENAME.ExecutionHead)) && (
                    <>
                      <TableCell component="th"> {row?.amountPaid} </TableCell>
                      <TableCell component="th"> {row?.totalAmountRefundedArray?.reduce((sum, item) => { return sum + item?.amountRefunded; }, 0)} </TableCell>
                      <TableCell component="th">
                        <TextField
                          key={index}
                          id={row._id}
                          name={`refundAmount-${index}`}
                          size="small"
                          value={refundAmount[index] ? refundAmount[index] : row?.refundAmount || 0}
                          onChange={(e) => handleRefundAmountChange(index, e.target.value)}
                          type="number"
                          label='Amount to be refunded'
                          fullWidth
                          variant="outlined"
                        />
                      </TableCell>
                      <TableCell component="th">{row?.amountPaid - ((refundAmount[index] ? refundAmount[index] : row?.refundAmount) + row?.totalAmountRefundedArray?.reduce((sum, item) => { return sum + item?.amountRefunded; }, 0))}</TableCell>
                    </>
                  )}
                  {(userDetails.roles.find(role => role.name === ROLENAME.DGM_Ops || role.name === ROLENAME.ExecutionHead)) &&
                    <>
                      <TableCell component="th">{row?.totalAmountRefundedArray?.reduce((sum, item) => { return sum + item?.amountRefunded }, 0)}</TableCell>
                      <TableCell component="th">{row?.refundAmount ? row?.refundAmount : 0}</TableCell>
                    </>
                  }
                  <TableCell component="th">{row?.refundRaiseUser ? row?.refundRaiseUser?.name : '-'}</TableCell>
                  <TableCell component="th">
                    <Grid style={{ display: 'flex', gap: 5, justifyContent: 'center', alignItems: 'center' }}>
                      <Button
                        color="primary"
                        variant="outlined"
                        onClick={() => handleApprove(row)}
                      >
                        Approve
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        onClick={() => handleReject(row)}
                      >
                        Reject
                      </Button>
                    </Grid>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <div>
        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
          <DialogTitle>Refund Request Approval</DialogTitle>
          <div style={{ padding: "16px" }}>
            {/* Show this table value when chm raise refund request */}
            {(userDetails.roles.find(role => role.name === ROLENAME.DGM_Ops || role.name === ROLENAME.ExecutionHead) && status === 'Approved') && (
              <TableContainer style={{ marginTop: 5 }}>
                <Table size="small">
                  <TableBody>

                    <TableRow>
                      <TableCell>Delay Penality</TableCell>
                      <TableCell>
                        <TextField
                          name="delayPenality"
                          size="small"
                          value={items?.delayPenality}
                          onChange={(e) => handleChmItems(e)}
                          type="number"
                          label="Delay Penality"
                          fullWidth
                          variant="outlined"
                        />
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Damages</TableCell>
                      <TableCell>
                        <TextField
                          name="damages"
                          size="small"
                          value={items?.damages}
                          onChange={(e) => handleChmItems(e)}
                          type="number"
                          label="Damages"
                          fullWidth
                          variant="outlined"
                        />
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Good Will Discount</TableCell>
                      <TableCell>
                        <TextField
                          name="goodWillDiscount"
                          size="small"
                          value={items?.goodWillDiscount}
                          onChange={(e) => handleChmItems(e)}
                          type="number"
                          label="Good Will Discount"
                          fullWidth
                          variant="outlined"
                        />
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Others</TableCell>
                      <TableCell>
                        <TextField
                          name="others"
                          size="small"
                          value={items?.others}
                          onChange={(e) => handleChmItems(e)}
                          type="number"
                          label="Others"
                          fullWidth
                          variant="outlined"
                        />
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Referral Bonus</TableCell>
                      <TableCell>
                        <TextField
                          name="referralBonus"
                          size="small"
                          value={items?.referralBonus}
                          onChange={(e) => handleChmItems(e)}
                          type="number"
                          label="Referral Bonus"
                          fullWidth
                          variant="outlined"
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            <TextField
              id="outlined-basic"
              label="Remark"
              variant="outlined"
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              fullWidth
            />
          </div>
          <DialogActions>
            <Button
              onClick={() => setOpenDialog(false)}
              variant="outlined"
              color="primary"
            >
              CANCEL
            </Button>
            <Button
              onClick={() => updateRefundRequestStatus()}
              variant="outlined"
              color="secondary"
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(
  RefundRequestApprovalView
);